import {
  ICalendar,
  GoogleCalendar,
  YahooCalendar,
  OutlookCalendar,
} from "datebook";
import { Button, Dropdown, Menu, Space } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faApple,
  faGoogle,
  faYahoo,
  faMicrosoft,
} from "@fortawesome/free-brands-svg-icons";
import { faCalendarPlus } from "@fortawesome/free-solid-svg-icons";

const CalendarButton = ({
  title,
  description,
  start,
  end,
  size,
  display,
  type,
  style,
}) => {
  const eventConfig = {
    title: title,
    description: description,
    start: new Date(start),
    end: new Date(end),
  };

  const generateICalendar = () => {
    const icalendar = new ICalendar(eventConfig);
    icalendar.download();
  };

  const generateGoogleCalendar = () => {
    const googleCalendar = new GoogleCalendar(eventConfig);
    return googleCalendar.render();
  };

  const generateYahooCalendar = () => {
    const yahooCalendar = new YahooCalendar(eventConfig);
    return yahooCalendar.render();
  };

  const generateOutlookWebCalendar = () => {
    const outlookCalendar = new OutlookCalendar(eventConfig);
    return outlookCalendar.render();
  };

  const generateOffice365OutlookWebCalendar = () => {
    const outlookCalendar = new OutlookCalendar(eventConfig);
    outlookCalendar.setHost("office");
    return outlookCalendar.render();
  };

  const openLink = (url) => {
    window.open(url, "_blank");
  };

  const items = [
    {
      key: "googlecalendar",
      label: (
        <a onClick={() => onClick("googlecalendar")}>
          <FontAwesomeIcon icon={faGoogle} /> Google Calendar
        </a>
      ),
    },
    {
      key: "icalendar",
      label: (
        <a onClick={() => onClick("icalendar")}>
          <FontAwesomeIcon icon={faApple} /> Apple Calendar
        </a>
      ),
    },
    {
      key: "outlook",
      label: (
        <a onClick={() => onClick("outlook")}>
          <FontAwesomeIcon icon={faMicrosoft} /> Outlook
        </a>
      ),
    },
    {
      key: "weboutlook",
      label: (
        <a onClick={() => onClick("weboutlook")}>
          <FontAwesomeIcon icon={faMicrosoft} /> Outlook.com
        </a>
      ),
    },
    {
      key: "office",
      label: (
        <a onClick={() => onClick("office")}>
          <FontAwesomeIcon icon={faMicrosoft} /> Office 365
        </a>
      ),
    },
    {
      key: "yahoo",
      label: (
        <a onClick={() => onClick("yahoo")}>
          <FontAwesomeIcon icon={faYahoo} /> Yahoo!
        </a>
      ),
    },
  ];

  const onClick = (value) => {
    switch (value) {
      case "googlecalendar":
        openLink(generateGoogleCalendar());
        break;
      case "icalendar":
        generateICalendar();
        break;
      case "outlook":
        generateICalendar();
        break;
      case "weboutlook":
        openLink(generateOutlookWebCalendar());
        break;
      case "office":
        openLink(generateOffice365OutlookWebCalendar());
        break;
      case "yahoo":
        openLink(generateYahooCalendar());
        break;
      default:
        openLink(generateGoogleCalendar());
        break;
    }
  };

  return (
    <Dropdown menu={{ items }} placement="bottomCenter">
      <Button size={size} type={type} style={style} block>
        <Space>
          <FontAwesomeIcon icon={faCalendarPlus} />
          {display || "Add to Calendar"}
        </Space>
      </Button>
    </Dropdown>
  );
};

export default CalendarButton;
